import { useState } from "react";
import { copyFormsAPI, deleteFormFromVisitsAPI, getForms, getVisitsWithFormByTitleAPI, replicateFormToVisitsAPI } from "../../../api/protocol";
import { HandleApiError } from "../../../components/Notifications/APIErrorHandler";

export const useForms = () => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchData = async (protocolId, visitId) => {
        try {
            setIsLoading(true);
            const response = await getForms(protocolId, visitId);
            setData(response.data.sort((function (a, b) { return a.order - b.order; })));
            setIsLoading(false);
        }
        catch (error) {
            HandleApiError(error);
            setIsLoading(false);
        }
    }

    return [fetchData, data, setData, isLoading];
}

export const useCopyForms = (protocolId, visitId) => {
    const [isLoading, setIsLoading] = useState(false);

    const copyForms = async (fromProtocolId, fromVisitId, formsToCopyIds) => {
        try {
            setIsLoading(true);
            const response = await copyFormsAPI(protocolId, visitId, fromProtocolId, fromVisitId, formsToCopyIds);
            setIsLoading(false);

            return response;

        } catch (error) {
            HandleApiError(error);
            setIsLoading(false);

            return null;
        }
    }

    return [copyForms, isLoading];
}

export const useReplicateFormToVisits = () => {
    const [isLoading, setIsLoading] = useState(false);

    const replicateForm = async (protocolId, visitId, formId, visitIds) => {
        try {
            setIsLoading(true);
            const response = await replicateFormToVisitsAPI(protocolId, visitId, formId, visitIds);
            setIsLoading(false);
            return response;
        } catch (error) {
            HandleApiError(error);
            setIsLoading(false);
            return null;
        }
    };

    return [replicateForm, isLoading];
}

export const useDeleteFormFromVisits = () => {
    const [visits, setVisits] = useState([]);
    const [isLoadingVisits, setIsLoadingVisits] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const fetchVisitsWithSameForm = async (protocolId, excludeVisitId, title) => {
        try {
            setIsLoadingVisits(true);
            const response = await getVisitsWithFormByTitleAPI(protocolId, excludeVisitId, title);
            setVisits(response.data);
            setIsLoadingVisits(false);
        } catch (error) {
            HandleApiError(error);
            setIsLoadingVisits(false);
        }
    };

    const deleteFromVisits = async (protocolId, excludeVisitId, formTitle, visitIds) => {
        try {
            setIsDeleting(true);
            const response = await deleteFormFromVisitsAPI(protocolId, excludeVisitId, formTitle, visitIds);
            setIsDeleting(false);
            return response;
        } catch (error) {
            HandleApiError(error);
            setIsDeleting(false);
            return null;
        }
    };

    return [fetchVisitsWithSameForm, visits, isLoadingVisits, deleteFromVisits, isDeleting];
}